import RouteTemplate from 'ember-route-template';

export default RouteTemplate(
  <template>
    <div id='standby-ready' hidden></div>
  </template>,
);
